export const InvaderStatus = {
    OK: 'OK',
    DAMAGED: 'damaged',
    DESTROYED: 'destroyed',
} as const;

export type InvaderStatusType = typeof InvaderStatus[keyof typeof InvaderStatus];

export const InvaderStatusLabels: Record<InvaderStatusType, string> = {
    [InvaderStatus.OK]: 'OK',
    [InvaderStatus.DAMAGED]: 'Endommagé',
    [InvaderStatus.DESTROYED]: 'Détruit',
};

export const InvaderStatusColors: Record<InvaderStatusType, string> = {
    [InvaderStatus.OK]: 'var(--terminal-green)',
    [InvaderStatus.DAMAGED]: 'var(--terminal-yellow)',
    [InvaderStatus.DESTROYED]: 'var(--terminal-red)',
};

export const isValidStatus = (status: string): status is InvaderStatusType => {
    return Object.values(InvaderStatus).includes(status as InvaderStatusType);
};
